import { defineComponent as _defineComponent } from 'vue'
import {
  ContentDisplay,
  TableDisplay,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

import {
  CustomOperation,
  MonitoringBarrier
} from '@/modules/trade/services/custom-operations';

interface Props {
  customOperationData: CustomOperation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Barriers',
  props: {
    customOperationData: null
  },
  setup(__props: any) {



const monitoringBarriersColumns = [
  {
    getter: 'type',
    header: 'Tipo'
  },
  {
    getter: (monitoringBarrier: MonitoringBarrier) => {
      return monitoringBarrier.level.formatted;
    },
    header: 'Nível',
    align: 'right'
  },
  {
    getter: (monitoringBarrier: MonitoringBarrier) => {
      return monitoringBarrier.distance.formatted;
    },
    header: 'Distância',
    align: 'right'
  }
];

return { __sfc: true,monitoringBarriersColumns, ContentDisplay, TableDisplay, HeadingDisplay }
}

})